import { combineReducers } from 'redux';
import sidebarReducer from '../components/sidebar.component/sidebar.reducer';
import loginReducer from '../containers/login.container/login.reducer';
import loaderReducer from '../components/loader.component/loader.reducer';
import userReducer from '../containers/users.container/users.reducer';
import partnerReducer from '../containers/partners.container/partners.reducer';
import customerReducer from '../containers/customers.container/customers.reducer';
import siteReducer from '../containers/sites.container/sites.reducer';
import locationReducer from '../containers/locations.container/locations.reducer';
import floorReducer from '../containers/floors.container/floors.reducer';
import pantryReducer from '../containers/pantries.container/pantries.reducer';
import machineReducer from '../containers/machines.container/machines.reducer';
import homeReducer from '../containers/home.container/home.reducer';
import headerReducer from '../components/header.component/header.reducer';
import recipeCalibrationReducer from '../containers/recipe-calibration.container/recipe-calibration.reducer';

const reducer = {
    sidebarReducer,
    loginReducer,
    loaderReducer,
    userReducer,
    partnerReducer,
    customerReducer,
    siteReducer,
    locationReducer,
    floorReducer,
    pantryReducer,
    machineReducer,
    homeReducer,
    headerReducer,
    recipeCalibrationReducer
};

const combineReducer = combineReducers(reducer);

export default combineReducer;
